import { AxiosError } from 'axios';
import React from 'react';

import { Typography } from '@mui/material';
import Paper from 'components/paper';

type Props = {
  error: AxiosError | null;
};

const Error: React.FC<Props> = ({ error }) => {
  return !!error ? (
    <Paper
      transparent
      sx={{
        gap: 2,
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Typography variant="caption">Error</Typography>
      <Typography variant="h1">
        {error.name}: {error.message}
      </Typography>
      <Paper
        sx={{
          overflow: 'auto',
        }}>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </Paper>
    </Paper>
  ) : null;
};

export default Error;
